import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { login } from '../../store/session';
import NavBar from '../SplashPage/NavBar/NavBar';
// Logo will be loaded from public folder

import './LoginForm.css';

const LoginForm = () => {
  const [errors, setErrors] = useState([]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(state => state.session.user);
  const dispatch = useDispatch();

  const onLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors([]);
    
    try {
      // Start both the login and a minimum delay
      const [data] = await Promise.all([
        dispatch(login(email, password)),
        new Promise(resolve => setTimeout(resolve, 1500)) // Minimum 1.5 second loading
      ]);
      
      if (data) {
        // Login failed - show errors and stop loading
        setErrors(data);
        setIsLoading(false);
      } else {
        // Login successful - wait a bit more then allow redirect
        setTimeout(() => {
          setIsLoading(false);
        }, 300); // Small additional delay for smooth transition
      }
    } catch (error) {
      setErrors(['An error occurred during login. Please try again.']);
      setIsLoading(false);
    }
  };

  const updateEmail = (e) => {
    setEmail(e.target.value);
  };

  const updatePassword = (e) => {
    setPassword(e.target.value);
  };

  if (user && !isLoading) {
    return <Redirect to='/' />;
  }

  return (
    <div>
      <div>
        <NavBar />
      </div>
      <div className='form-page'>
        <div className='form-container'>
          <div className='form'>
            <div className='form-header'>
              <div className='venmo-logo-large'>
                <img src="/images/venmo-logo.svg" alt="Venmo Logo" />
              </div>
              <h2 className='sign-in-text'>
                Sign in to Venmo
              </h2>
            </div>
            
            <div className='allItems'>
              <div className='login-items'>
                <div className="error-div">
                  {errors.map((error, ind) => (
                    <div key={ind} className='errors'>{error}</div>
                  ))}
                </div>
              </div>
            <form onSubmit={onLogin}>
              <div className='login-items email-div'>
                <label htmlFor='email' className='label email'>Email: </label>
                <input
                className='input-fields'
                  name='email'
                  type='text'
                  placeholder='Email'
                  value={email}
                  onChange={updateEmail}
                />
              </div>
              <div className='login-items password-div'>
                <label htmlFor='password' className='label'>{`Password:`}</label>
                <input
                  className='input-fields'
                  name='password'
                  type='password'
                  placeholder='Password'
                  value={password}
                  onChange={updatePassword}
                />
              </div>
              <button type='submit' className='login-items login-btn' disabled={isLoading}>
                {isLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin login-spinner"></i>
                    Signing in...
                  </>
                ) : (
                  'Login'
                )}
              </button>
            </form>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;

// Debug function to test localStorage persistence
if (process.env.NODE_ENV === 'development') {
  window.debugVenmoAuth = {
    checkCurrentUser: () => {
      const user = localStorage.getItem('venmo_current_user');
      console.log('Current stored user:', user ? JSON.parse(user) : 'None');
    },
    clearLogin: () => {
      localStorage.removeItem('venmo_current_user');
      console.log('Cleared stored login');
    },
    getAllUsers: async () => {
      const { userService } = await import('../../utils/userService');
      console.log('All available users:', userService.getAllUsers());
    }
  };
}
